/*

document.querySelectorAll('.add-to-cart').forEach(button => {
	button.addEventListener('click', function(event) {
		event.preventDefault();
		fetch('/cart/add.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ id: this.dataset.variantId, quantity: 1 })
		}).then(response => response.json()).then(data => {
			alert('Added to cart!');
		});
	});
});
*/
document.addEventListener("DOMContentLoaded", function() {
	// Find the Judge.me badge
	const judgeBadge = document.querySelector('.jdgm-prev-badge');

	if (judgeBadge) {
		// Get the average rating from the data attribute
		const averageRating = judgeBadge.getAttribute('data-average-rating');

		// Find your custom rating container
		const customRating = document.querySelector('.judge-me-rating');
		if (customRating) {
			// Display the average rating
			customRating.textContent = averageRating;
		}
	}
});
jQuery(document).ready(function($) {

	$('.toggle-child').hide();
	$('.toggle-first-chiid').show();

	$('.toggle-header').click(function() {
		$(this).next('.toggle-child').slideToggle();
		$(this).toggleClass('toggle-active');
	});
	$('.toggle-bottom').click(function() {
		$(this).parent().parent().find('h2').toggleClass('toggle-active');
		$(this).parent().slideUp();

		$('html, body').animate({
			scrollTop: $($(this).parent().parent()).offset().top-8
		}, 1000);
	});



	$('#myCarousel .item:first').addClass('active');
	var myCarousel = $("#myCarousel");

	myCarousel.owlCarousel({
		nav: true,
		dots: true,
		loop: false,
		margin: 0,
		slideBy: 1,
		items: 1,
		navText: '',
		navRewind:false,
		responsiveClass:true,
/*		responsiveClass:true,
		responsive:{
			0:{
				nav: false,
				dots: true,
				margin: 0,
				items:1
			},
			600:{
				nav: false,
				dots: true,
				margin:10,
				items:2
			},
			750:{
				nav: false,
				dots: true,
				margin:10,
				items:3
			},
			1001:{
				dots: false,
				nav:true,
				margin:40,
				items:4,
			}
		}*/
	})

});